<template>
<div class="chapter">
<div class="inner_page">
<p class="sp"> </p>
<p class="TNI-1">The author and publisher have provided this e-book to you without Digital Rights Management software (DRM) applied so that you can enjoy reading it on your personal devices. This e-book is for your personal use only. You may not print or post this e-book, or make this e-book publicly available in any way. You may not copy, reproduce, or upload this e-book, other than to read it on one of your personal devices.</p>
<p class="STNI"><span class="ePub-B">Copyright infringement is against the law. If you believe the copy of this e-book you are reading infringes on the author’s copyright, please notify the publisher at: <a href="http://us.macmillanusa.com/piracy" target="_blank">us.macmillanusa.com/piracy</a>.</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// copyrightnotice.vue?53c9c0f2